import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTeamStyle0 = cosmosIconCss;

const CosmosIconTeam$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTeam extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7f978f0ea231080cc5b4d9a10c50e8b70671a4a6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4703e178f86ed243b5e40420464c565efed0a342', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '45e2c86a42c0fe8198fc224c79bb59d4c40bf063', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.57 6.21c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L5 8a2.12 2.12 0 0 1 .57-1.79 2.61 2.61 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8Zm7 0c.403.503.56 1.159.43 1.79l-.36 2.47a2.05 2.05 0 0 1-2.17 1.9 2.05 2.05 0 0 1-2.17-1.9L12 8a2.12 2.12 0 0 1 .57-1.79 2.61 2.61 0 0 1 2-.8 2.58 2.58 0 0 1 2 .8ZM10 13.24a.5.5 0 0 0-.51 0 3.57 3.57 0 0 1-3.87 0 .52.52 0 0 0-.51 0A3.5 3.5 0 0 0 3 16.34v.16a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2-3.1Zm3.53.94A5.76 5.76 0 0 1 14 16.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.16a3.47 3.47 0 0 0-2.05-3.06.5.5 0 0 0-.51 0 3.39 3.39 0 0 1-1.93.57 3.76 3.76 0 0 1-.67-.06c-.31-.06-.44.12-.31.39Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTeamStyle0; }
}, [1, "cosmos-icon-team", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-team"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-team":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTeam$1);
            }
            break;
    } });
}

const CosmosIconTeam = CosmosIconTeam$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTeam, defineCustomElement };
